export const adfoxOptions = {
    "main": {
        "topad": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: "full-topad-pc",
                    params: {
                        p1: "ctkpt",
                        p2: "hpbs",
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: "full-topad-mob",
                    params: {
                        p1: "daqjj",
                        p2: "itrw",
                    }
                }],
            "prevPc": [
                {
                    ownerId: 407082,
                    containerId: "prv-topad-pc",
                    params: {
                        p1: "czcqr",
                        p2: "injz",
                    }
                }],
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: "prv-topad-mob",
                    params: {
                        p1: "daqjf",
                        p2: "itru",
                    }
                }],
        },
        "ir1": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: "full-ir-1-pc",
                    params: {
                        p1: "cxctp",
                        p2: "ibgh",
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: "full-ir-1-mob",
                    params: {
                        p1: "daqjl",
                        p2: "itrx",
                    }
                }],
            "prevPc": [
                {
                    ownerId: 407082,
                    containerId: "prv-ir-1-pc",
                    params: {
                        p1: "czcpp",
                        p2: "injy",
                    }
                }],
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: "prv-ir-1-mob",
                    params: {
                        p1: "daqjh",
                        p2: "itrv",
                    }
                }],
        },
        "ir2": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: "full-ir-2-pc",
                    params: {
                        p1: "ctkpw",
                        p2: "hpbt",
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: "full-ir-2-mob",
                    params: {
                        p1: "daqjm",
                        p2: "itry",
                    }
                }],
        },
        "ir3": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: "full-ir-3-pc",
                    params: {
                        p1: "czcyp",
                        p2: "inlf",
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: "full-ir-3-mob",
                    params: {
                        p1: "daruh",
                        p2: "iuak",
                    }
                }],
        },
        "ir4": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: "full-ir-4-pc",
                    params: {
                        p1: "czcyu",
                        p2: "inlg",
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: "full-ir-4-mob",
                    params: {
                        p1: "darul",
                        p2: "iual",
                    }
                }],
        },
        "ir5": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: "full-ir-5-pc",
                    params: {
                        p1: "czcyv",
                        p2: "inlh",
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: "full-ir-5-mob",
                    params: {
                        p1: "daruo",
                        p2: "iuam",
                    }
                }],
        },
        "aa1": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: "full-aa-1-pc",
                    params: {
                        p1: "ctkqh",
                        p2: "hpbu",
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: "full-aa-1-mob",
                    params: {
                        p1: "darue",
                        p2: "iuaj",
                    }
                }],
            "prevPc": [
                {
                    ownerId: 407082,
                    containerId: "prv-aa-1-pc",
                    params: {
                        p1: "czcqs",
                        p2: "inkd",
                    }
                }],
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: "prv-aa-1-mob",
                    params: {
                        p1: "darus",
                        p2: "iuai",
                    }
                }],
        },
        "floorad": {
            "fullPc": null,
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: "adfox_158591889817585646",
                    params: {
                        p1: "ctkpv",
                        p2: "hpbv",
                    }
                }],
            "prevPc": null,
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: "adfox_158591889817585646",
                    params: {
                        p1: "ctkpv",
                        p2: "hpbv",
                    }
                }],
        },
        "fullscreen": {
            "fullPc": null,
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: "mob_fullscreen",
                    params: {
                        p1: 'ctjoj',
                        p2: 'hiuq',
                    }
                }],
            "prevPc":null,
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: "mob_fullscreen",
                    params: {
                        p1: 'ctjoj',
                        p2: 'hiuq',
                    }
                }],
        },
    },
    "14556": {
        "topad": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338225619129666',
                    params: {
                        p1: 'dfcja',
                        p2: 'jhke',
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338225389828666',
                    params: {
                        p1: 'dfcjb',
                        p2: 'jhkf',
                    }
                }],
            "prevPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338228813572666',
                    params: {
                        p1: 'dfciy',
                        p2: 'jhkc',
                    }
                }],
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338228553905666',
                    params: {
                        p1: 'dfciz',
                        p2: 'jhkd',
                    }
                }],
        },
        "ir1": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338221561046666',
                    params: {
                        p1: 'dfcje',
                        p2: 'jhki',
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338220520236666',
                    params: {
                        p1: 'dfcjf',
                        p2: 'jhkk',
                    }
                }],
            "prevPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338228132479666',
                    params: {
                        p1: 'dfcjc',
                        p2: 'jhkg',
                    }
                }],
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338227704814666',
                    params: {
                        p1: 'dfcjd',
                        p2: 'jhkh',
                    }
                }],
        },
        "ir2": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338223688491666',
                    params: {
                        p1: 'dfcjp',
                        p2: 'jhkv',
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338221964267666',
                    params: {
                        p1: 'dfcjq',
                        p2: 'jhkw',
                    }
                }],
        },
        "ir3": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338223934526666',
                    params: {
                        p1: 'dfcjr',
                        p2: 'jhkx',
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_1733822252984666',
                    params: {
                        p1: 'dfcjs',
                        p2: 'jhky',
                    }
                }],
        },
        "ir4": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338224588657666',
                    params: {
                        p1: 'dfcjt',
                        p2: 'jhkz'
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_1733822435425666',
                    params: {
                        p1: 'dfcju',
                        p2: 'jhla'
                    }
                }],
        },
        "ir5": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338225153798666',
                    params: {
                        p1: 'dfcjv',
                        p2: 'jhlb'
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338224852785666',
                    params: {
                        p1: 'dfcjw',
                        p2: 'jhlc'
                    }
                }],
        },
        "aa1": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338208709238666',
                    params: {
                        p1: 'dfcji',
                        p2: 'jhkp',
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338208193697666',
                    params: {
                        p1: 'dfcjj',
                        p2: 'jhkq',
                    }
                }],
            "prevPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_1733822610018666',
                    params: {
                        p1: 'dfcjg',
                        p2: 'jhkl',
                    }
                }],
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338225865324666',
                    params: {
                        p1: 'dfcjh',
                        p2: 'jhkn',
                    }
                }],
        },
        "floorad": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338209446245666',
                    params: {
                        p1: 'dfcjn',
                        p2: 'jhkt',
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338209198043666',
                    params: {
                        p1: 'dfcjo',
                        p2: 'jhku',
                    }
                }],
            "prevPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338226567754666',
                    params: {
                        p1: 'dfcjk',
                        p2: 'jhkr',
                    }
                }],
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_1733822630518666',
                    params: {
                        p1: 'dfcjm',
                        p2: 'jhks',
                    }
                }],
        },
        "fullscreen": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_1733821021438666',
                    params: {
                        p1: 'dfciw',
                        p2: 'jhka'
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_1733820964622666',
                    params: {
                        p1: 'dfcix',
                        p2: 'jhkb',
                    }
                }],
            "prevPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338227054516666',
                    params: {
                        p1: 'dfcit',
                        p2: 'jhjy'
                    }
                }],
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338226807264666',
                    params: {
                        p1: 'dfciv',
                        p2: 'jhjz',
                    }
                }],
        },
    },
    "BY": {
        "topad": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338225619129666',
                    params: {
                        p1: 'dfcja',
                        p2: 'jhke',
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338225389828666',
                    params: {
                        p1: 'dfcjb',
                        p2: 'jhkf',
                    }
                }],
            "prevPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338228813572666',
                    params: {
                        p1: 'dfciy',
                        p2: 'jhkc',
                    }
                }],
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338228553905666',
                    params: {
                        p1: 'dfciz',
                        p2: 'jhkd',
                    }
                }],
        },
        "ir1": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338221561046666',
                    params: {
                        p1: 'dfcje',
                        p2: 'jhki',
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338220520236666',
                    params: {
                        p1: 'dfcjf',
                        p2: 'jhkk',
                    }
                }],
            "prevPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338228132479666',
                    params: {
                        p1: 'dfcjc',
                        p2: 'jhkg',
                    }
                }],
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338227704814666',
                    params: {
                        p1: 'dfcjd',
                        p2: 'jhkh',
                    }
                }],
        },
        "ir2": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338223688491666',
                    params: {
                        p1: 'dfcjp',
                        p2: 'jhkv',
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338221964267666',
                    params: {
                        p1: 'dfcjq',
                        p2: 'jhkw',
                    }
                }],
        },
        "ir3": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338223934526666',
                    params: {
                        p1: 'dfcjr',
                        p2: 'jhkx',
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_1733822252984666',
                    params: {
                        p1: 'dfcjs',
                        p2: 'jhky',
                    }
                }],
        },
        "ir4": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338224588657666',
                    params: {
                        p1: 'dfcjt',
                        p2: 'jhkz'
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_1733822435425666',
                    params: {
                        p1: 'dfcju',
                        p2: 'jhla'
                    }
                }],
        },
        "ir5": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338225153798666',
                    params: {
                        p1: 'dfcjv',
                        p2: 'jhlb'
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338224852785666',
                    params: {
                        p1: 'dfcjw',
                        p2: 'jhlc'
                    }
                }],
        },
        "aa1": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338208709238666',
                    params: {
                        p1: 'dfcji',
                        p2: 'jhkp',
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338208193697666',
                    params: {
                        p1: 'dfcjj',
                        p2: 'jhkq',
                    }
                }],
            "prevPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_1733822610018666',
                    params: {
                        p1: 'dfcjg',
                        p2: 'jhkl',
                    }
                }],
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338225865324666',
                    params: {
                        p1: 'dfcjh',
                        p2: 'jhkn',
                    }
                }],
        },
        "floorad": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338209446245666',
                    params: {
                        p1: 'dfcjn',
                        p2: 'jhkt',
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338209198043666',
                    params: {
                        p1: 'dfcjo',
                        p2: 'jhku',
                    }
                }],
            "prevPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338226567754666',
                    params: {
                        p1: 'dfcjk',
                        p2: 'jhkr',
                    }
                }],
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_1733822630518666',
                    params: {
                        p1: 'dfcjm',
                        p2: 'jhks',
                    }
                }],
        },
        "fullscreen": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_1733821021438666',
                    params: {
                        p1: 'dfciw',
                        p2: 'jhka'
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_1733820964622666',
                    params: {
                        p1: 'dfcix',
                        p2: 'jhkb',
                    }
                }],
            "prevPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338227054516666',
                    params: {
                        p1: 'dfcit',
                        p2: 'jhjy'
                    }
                }],
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338226807264666',
                    params: {
                        p1: 'dfciv',
                        p2: 'jhjz',
                    }
                }],
        },
    },
    "KZ": {
        "topad": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338225619129666',
                    params: {
                        p1: 'dfcja',
                        p2: 'jhke',
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338225389828666',
                    params: {
                        p1: 'dfcjb',
                        p2: 'jhkf',
                    }
                }],
            "prevPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338228813572666',
                    params: {
                        p1: 'dfciy',
                        p2: 'jhkc',
                    }
                }],
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338228553905666',
                    params: {
                        p1: 'dfciz',
                        p2: 'jhkd',
                    }
                }],
        },
        "ir1": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338221561046666',
                    params: {
                        p1: 'dfcje',
                        p2: 'jhki',
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338220520236666',
                    params: {
                        p1: 'dfcjf',
                        p2: 'jhkk',
                    }
                }],
            "prevPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338228132479666',
                    params: {
                        p1: 'dfcjc',
                        p2: 'jhkg',
                    }
                }],
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338227704814666',
                    params: {
                        p1: 'dfcjd',
                        p2: 'jhkh',
                    }
                }],
        },
        "ir2": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338223688491666',
                    params: {
                        p1: 'dfcjp',
                        p2: 'jhkv',
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338221964267666',
                    params: {
                        p1: 'dfcjq',
                        p2: 'jhkw',
                    }
                }],
        },
        "ir3": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338223934526666',
                    params: {
                        p1: 'dfcjr',
                        p2: 'jhkx',
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_1733822252984666',
                    params: {
                        p1: 'dfcjs',
                        p2: 'jhky',
                    }
                }],
        },
        "ir4": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338224588657666',
                    params: {
                        p1: 'dfcjt',
                        p2: 'jhkz'
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_1733822435425666',
                    params: {
                        p1: 'dfcju',
                        p2: 'jhla'
                    }
                }],
        },
        "ir5": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338225153798666',
                    params: {
                        p1: 'dfcjv',
                        p2: 'jhlb'
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338224852785666',
                    params: {
                        p1: 'dfcjw',
                        p2: 'jhlc'
                    }
                }],
        },
        "aa1": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338208709238666',
                    params: {
                        p1: 'dfcji',
                        p2: 'jhkp',
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338208193697666',
                    params: {
                        p1: 'dfcjj',
                        p2: 'jhkq',
                    }
                }],
            "prevPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_1733822610018666',
                    params: {
                        p1: 'dfcjg',
                        p2: 'jhkl',
                    }
                }],
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338225865324666',
                    params: {
                        p1: 'dfcjh',
                        p2: 'jhkn',
                    }
                }],
        },
        "floorad": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338209446245666',
                    params: {
                        p1: 'dfcjn',
                        p2: 'jhkt',
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338209198043666',
                    params: {
                        p1: 'dfcjo',
                        p2: 'jhku',
                    }
                }],
            "prevPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338226567754666',
                    params: {
                        p1: 'dfcjk',
                        p2: 'jhkr',
                    }
                }],
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_1733822630518666',
                    params: {
                        p1: 'dfcjm',
                        p2: 'jhks',
                    }
                }],
        },
        "fullscreen": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_1733821021438666',
                    params: {
                        p1: 'dfciw',
                        p2: 'jhka'
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_1733820964622666',
                    params: {
                        p1: 'dfcix',
                        p2: 'jhkb',
                    }
                }],
            "prevPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338227054516666',
                    params: {
                        p1: 'dfcit',
                        p2: 'jhjy'
                    }
                }],
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338226807264666',
                    params: {
                        p1: 'dfciv',
                        p2: 'jhjz',
                    }
                }],
        },
    },
    "EXT": {
        "topad": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338225619129666',
                    params: {
                        p1: 'dfcja',
                        p2: 'jhke',
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338225389828666',
                    params: {
                        p1: 'dfcjb',
                        p2: 'jhkf',
                    }
                }],
            "prevPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338228813572666',
                    params: {
                        p1: 'dfciy',
                        p2: 'jhkc',
                    }
                }],
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338228553905666',
                    params: {
                        p1: 'dfciz',
                        p2: 'jhkd',
                    }
                }],
        },
        "ir1": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338221561046666',
                    params: {
                        p1: 'dfcje',
                        p2: 'jhki',
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338220520236666',
                    params: {
                        p1: 'dfcjf',
                        p2: 'jhkk',
                    }
                }],
            "prevPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338228132479666',
                    params: {
                        p1: 'dfcjc',
                        p2: 'jhkg',
                    }
                }],
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338227704814666',
                    params: {
                        p1: 'dfcjd',
                        p2: 'jhkh',
                    }
                }],
        },
        "ir2": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338223688491666',
                    params: {
                        p1: 'dfcjp',
                        p2: 'jhkv',
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338221964267666',
                    params: {
                        p1: 'dfcjq',
                        p2: 'jhkw',
                    }
                }],
        },
        "ir3": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338223934526666',
                    params: {
                        p1: 'dfcjr',
                        p2: 'jhkx',
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_1733822252984666',
                    params: {
                        p1: 'dfcjs',
                        p2: 'jhky',
                    }
                }],
        },
        "ir4": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338224588657666',
                    params: {
                        p1: 'dfcjt',
                        p2: 'jhkz'
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_1733822435425666',
                    params: {
                        p1: 'dfcju',
                        p2: 'jhla'
                    }
                }],
        },
        "ir5": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338225153798666',
                    params: {
                        p1: 'dfcjv',
                        p2: 'jhlb'
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338224852785666',
                    params: {
                        p1: 'dfcjw',
                        p2: 'jhlc'
                    }
                }],
        },
        "aa1": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338208709238666',
                    params: {
                        p1: 'dfcji',
                        p2: 'jhkp',
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338208193697666',
                    params: {
                        p1: 'dfcjj',
                        p2: 'jhkq',
                    }
                }],
            "prevPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_1733822610018666',
                    params: {
                        p1: 'dfcjg',
                        p2: 'jhkl',
                    }
                }],
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338225865324666',
                    params: {
                        p1: 'dfcjh',
                        p2: 'jhkn',
                    }
                }],
        },
        "floorad": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338209446245666',
                    params: {
                        p1: 'dfcjn',
                        p2: 'jhkt',
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338209198043666',
                    params: {
                        p1: 'dfcjo',
                        p2: 'jhku',
                    }
                }],
            "prevPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338226567754666',
                    params: {
                        p1: 'dfcjk',
                        p2: 'jhkr',
                    }
                }],
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_1733822630518666',
                    params: {
                        p1: 'dfcjm',
                        p2: 'jhks',
                    }
                }],
        },
        "fullscreen": {
            "fullPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_1733821021438666',
                    params: {
                        p1: 'dfciw',
                        p2: 'jhka'
                    }
                }],
            "fullMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_1733820964622666',
                    params: {
                        p1: 'dfcix',
                        p2: 'jhkb',
                    }
                }],
            "prevPc": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338227054516666',
                    params: {
                        p1: 'dfcit',
                        p2: 'jhjy'
                    }
                }],
            "prevMob": [
                {
                    ownerId: 407082,
                    containerId: 'adfox_17338226807264666',
                    params: {
                        p1: 'dfciv',
                        p2: 'jhjz',
                    }
                }],
        },
    }
}
